import { Navigate } from 'react-router-dom';
import { useState } from 'react';
import ShippingHeader from '../header/ShippingHeader';
import methods from '../../services/utility';

const ShippingLayout = ({ component: Component, ...rest }) => {
    const isUserLogedin = methods.checkUserLogin();
    return (
        <div className='container-fluid'>
            {isUserLogedin ?
                <>
                    <ShippingHeader />
                    <div className='row'>
                        <div className={`col-lg-12 mt-3 mx-auto`}>
                            <Component {...rest} />
                        </div>
                    </div>
                </>
                :
                <Navigate to="/login" />
            }
        </div>
    )
};

export default ShippingLayout;